<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <div class="column is-3">
                    <aside class="menu">
                        <div
                            v-for="nav in menu"
                            :key="nav.headline"
                            style="margin-bottom: 1rem"
                        >
                            <p class="menu-label">
                                {{ nav.headline }}
                            </p>
                            <ul class="menu-list" v-if="nav.items">
                                <li
                                    v-for="sub in nav.items"
                                    :key="sub.label"
                                    @click.prevent="onSelectMenu(sub)"
                                >
                                    <a
                                        :class="{
                                            'is-active':
                                                sub === activeComponent,
                                        }"
                                        >{{ sub.label }}</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </aside>
                </div>
                <div class="column" v-if="activeComponent">
                    <component
                        :is="activeComponent.component"
                        :headline="activeComponent.label"
                        :tab="activeComponent.key"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import EconomicIntegration from "./integrations/EconomicIntegration";
import ApiExports from "./integrations/ApiExports";

export default {
    name: "Company",
    components: {},
    data() {
        return {
            menu: [
                {
                    headline: "Integrationer",
                    items: [
                        {
                            label: "API exports",
                            component: ApiExports,
                        },
                        {
                            label: "E-conomic",
                            component: EconomicIntegration,
                        },
                    ],
                },
            ],
            activeComponent: null,
        };
    },
    watch: {
        $route(to, from) {
            let tab = to.query.tab;
            if (tab) {
                this.activeComponent = this.menu[1].items.find(
                    (item) => item.key === tab
                );
            }
        },
    },
    methods: {
        onSelectMenu(activeComponent) {
            this.$router.push({ query: { tab: activeComponent.key } });

            this.activeComponent = activeComponent;
        },
    },
    mounted() {
        let params = new URLSearchParams(window.location.search);
        let tab = params.get("tab");

        if (tab) {
            this.activeComponent = this.menu[1].items.find(
                (item) => item.key === tab
            );
        }

        if (!this.activeComponent) {
            this.activeComponent = this.menu[0].items[0];
        }

        this.$store.dispatch("loadLocales");
    },
};
</script>

<style scoped></style>
